export function composeGroupPath(options) {
    const { groupId, configurationObjectPath } = options;
    return `${configurationObjectPath}|${groupId}`;
}
//# sourceMappingURL=composeGroupPath.js.map